<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        .st0 {
          fill: #94be57;
        }
        .st1 {
          fill: #242424;
        }
      </style>
    </defs>
    <path class="st1" d="M2.41.01C2.5.01,14.11.01,19.82,0,20.72,0,21.54.26,22.35.54c1.38.49,2.62,1.31,3.62,2.37.53.56.99,1.19,1.39,1.85,1.05,1.72,1.34,3.61,1.19,5.59-.05.71-.15,1.42-.46,2.07-.35.75-.98,1.21-1.63,1.66-1.05.71-2.1,1.44-3.15,2.17-.91.63-1.83,1.24-2.74,1.85-.98.67-1.96,1.34-2.96,2-.44.3-.89.6-1.31.89v7.42h.65c1.39.03,2.75-.04,4.09-.44s2.55-1.01,3.5-2.07c.79-.87,1.12-1.93,1.32-3.05.19-.99.14-2.03-.14-3.01-.2-.69-.54-1.35-1.01-1.89-.16-.18-.34-.33-.52-.48l2.98-2c.41.29.69.69.97,1.12.26.44.48.9.67,1.36.71,1.62.86,3.32.72,5.05-.07.87-.26,1.73-.59,2.55-.34.84-.72,1.68-1.34,2.37-.82.97-1.8,1.77-2.9,2.4-1.47.79-3.08,1.32-4.73,1.54-.57.08-1.14.14-1.72.14H2.42v-11.25l3.64,2.47v5.18h5.59v-3.2c-3.02-2.04-9.22-6.36-9.22-6.36V.01Z"/>
    <path class="st0" d="M12.34,20.45l-5.6-3.77V3.45c-.12,0,8.38-.03,12.03-.04.69-.01,1.39.05,2.07.2,1.09.25,2.07.67,2.9,1.43,1.02.95,1.39,2.15,1.48,3.49.04.67.07,1.34-.25,1.96-.26.5-1.62,1.47-1.85,1.63-1.13.76-2.26,1.53-3.38,2.28-.89.59-1.76,1.19-2.64,1.77-.03.03-.07.04-.14.07v-7.87l-4.63,3.11v8.98h0Z"/>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
